import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

interface PaymentResponse {
  msg: string;
  recordUpdateFailed: any;
  success: boolean;
  message?: string;
  transactionId?: string;
  paymentReceived?: boolean;
  error?: string;
}

interface HostedTokenResponse {
  token: string;
  success?: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthorizeNetService {
  constructor(private http: HttpClient) {}

  processPayment(paymentData: any): Observable<PaymentResponse> {
    return this.http.post<PaymentResponse>(
      `${environment.apiUrl}/authorize-net/v2/process-payment`, 
      paymentData
    );
  }

  getHostedPaymentToken(invoiceId: string, amount: number): Observable<HostedTokenResponse> {
    return this.http.post<HostedTokenResponse>(
      `${environment.apiUrl}/authorize-net/v2/get-hosted-token`, 
      { invoiceId, amount }
    );
  }
}